// Removed unused globalData export - not needed for current features

export const luxuryYacht = [
  {
    id: "luxury-yacht",
    type: "yacht",
    name: "Premium Yacht Experience in Durrës",
    location: "Durrës Marina",
    slug: "luxury-yacht-durres",
    maxCapacity: 11,
    description:
      "Experience the ultimate luxury on the Adriatic Sea with our premium yacht charter. Perfect for special occasions, corporate events, or simply indulging in the finest maritime experience. Our luxury yacht features spacious decks, elegant interiors, professional crew, gourmet catering options, and state-of-the-art amenities. Cruise along the stunning Albanian coastline, explore hidden coves, and enjoy VIP service with panoramic views of the Adriatic. Whether it's a romantic sunset cruise, a celebration with friends, or a corporate retreat, our yacht provides an unforgettable experience of elegance and comfort.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/yacht1.jpeg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/yacht1.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht2.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht3.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht4.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht5.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht6.jpeg`,
    ],
    // video: `${process.env.PUBLIC_URL}/videos/luxury-yacht.mp4`,
    price: "1300",
    priceType: "per 4 hours",
    time: "4 hours",
    rating: 5.0,
    number_of_reviews: 42,
    duration: "4 hours",
    language: "English, Albanian, Italian",
    itinerary: [
      { time: "10:00", activity: "Welcome aboard at Durrës Marina" },
      { time: "10:30", activity: "Departure & coastal cruise" },
      {
        time: "12:00",
        activity: "Swimming stop at secluded bay",
      },
      { time: "13:00", activity: "Gourmet lunch service onboard" },
      { time: "14:00", activity: "Return to marina" },
    ],
    included: [
      "Professional captain & crew",
      "Life jackets & safety equipment",
      "Fuel & marina fees",
      "Premium sound system",
      "Welcome drinks & 2 bottles of champagne",
      "Luxury sun deck & lounge areas",
      "Towels & beach amenities",
      "Water sports equipment",
      "Air conditioning",
      "Onboard restrooms",
      "Complimentary WiFi",
    ],
    notIncluded: [
      "Gourmet meals (can be arranged)",
      "Hotel pickup",
      "Gratuities",
    ],
    features: [
      "Spacious luxury yacht",
      "Professional crew service",
      "Premium amenities",
      "Water sports equipment",
      "Elegant interior design",
      "VIP experience",
      "Safety certified",
      "Full insurance coverage",
    ],
  },
];

export const hotelsData = [
  {
    id: "aquila d",
    type: "hotel",
    name: "Hotel Aquila D",
    slug: "hotel-aquila-d",
    time: "night",
    location: "Durres",
    description:
      "Modern hotel near the center with comfortable rooms and excellent amenities.",
    image: `${process.env.PUBLIC_URL}/images/hotels/hotel.jpg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/hotels/hotel.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/hotel2.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/hotel3.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/hotel4.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/dhoma.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/dhoma2.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/hotel5.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/hotel6.jpg`,
    ],
    // video: "/videos/hotels/vollga-hotel.mp4",
    price: "80",
    rating: 4.8,
    number_of_reviews: 45,
    duration: "Per night",
    language: "English, Albanian",
    itinerary: [],
    included: ["Breakfast", "Wi-Fi", "Parking", "Air conditioning"],
    notIncluded: ["Meals (lunch/dinner)", "Cleaning fee"],
  },
  {
    id: "ambasador",
    type: "hotel",
    name: "Hotel Ambasador",
    slug: "hotel-ambasador",
    location: "Durres",
    description:
      "In the Center Of City Durres with spacious rooms and a relaxing atmosphere.",
    image: `${process.env.PUBLIC_URL}/images/hotels/ambasador.jpg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/hotels/ambasador.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/ambasador1.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/ambasador2.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/ambasador3.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/ambasador4.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/ambasador5.jpg`,
      `${process.env.PUBLIC_URL}/images/hotels/ambasador6.jpg`,
    ],
    // video: "/videos/hotels/plazh-hotel.mp4",
    price: "90",
    time: "night",
    rating: 4.7,
    number_of_reviews: 38,
    duration: "Per night",
    language: "English, Albanian",
    itinerary: [],
    included: ["Breakfast", "Wi-Fi", "Parking", "Swimming pool"],
    notIncluded: ["Meals (lunch/dinner)", "Cleaning fee"],
  },
];

export const speedBoatData = [
  {
    id: "speedboat",
    type: "boat",
    slug: "quicksilver-tour",
    name: "Durrës: Amaizing SpeedBoat Tour",
    location: "Durrës Marina",
    maxCapacity: 11,
    description:
      "Choose from 2 amazing tour packages on the QuickSilver 805: Explore a WWII shipwreck (90 min), enjoy coastal views with water sports (90 min). Professional guides, modern boat with twin motors, unforgettable Albanian coast experience.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/quicksilver4.jpeg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver4.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver1.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver2.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver3.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver4.jpeg`,
      // `${process.env.PUBLIC_URL}/images/speedboat/quicksilver5.jpeg`,
      // `${process.env.PUBLIC_URL}/images/speedboat/quicksilver6.jpeg`,
      // `${process.env.PUBLIC_URL}/images/speedboat/quicksilver7.jpeg`,
    ],
    videos: [
      `${process.env.PUBLIC_URL}/videos/speedboat.mp4`,
      `${process.env.PUBLIC_URL}/videos/speedboat2.mp4`,
    ],
    // video: `${process.env.PUBLIC_URL}/videos/quicksilver-805.mp4`,
    price: "50",
    time: "90 minutes",
    // price_1_4_persons: "200",
    // price_5_8_persons: "350",
    rating: 5.0,
    number_of_reviews: 110,
    duration: "by agreement",
    language: "English, Albanian",
    itinerary: [
      { time: "09:00", activity: "Departure from Durrës Marina" },
      { time: "09:30", activity: "Cruise along the Adriatic coast" },
      { time: "10:00", activity: "Swimming and photo stop" },
      { time: "10:30", activity: "Return to marina" },
    ],
    included: ["Skipper", "Life jackets", "Fuel", "Music system"],
    notIncluded: ["Food & drinks", "Towels"],
    extras: {
      drinks: [
        { name: "Water", price: 2 },
        { name: "Beer", price: 5 },
        { name: "Cola", price: 3 },
        { name: "Champagne", price: 30 },
      ],
      food: [
        { name: "Pica", price: 15 },
        { name: "Sandwich", price: 10 },
      ],
      jetski: {
        name: "Jetski on Board",
        price: 50,
        duration: "15 min",
      },
    },
    availableTimes: ["09:00", "17:00"],
  },
  {
    id: "jet-ski",
    type: "boat",
    slug: "jet-ski-adventure",
    name: "Durrës: Jet Ski Adventure",
    location: "Durres Marina",
    maxCapacity: 11,
    description:
      "Experience the thrill of riding a jet ski on the beautiful Albanian coast. Choose between solo adventure or guided experience with a professional skipper.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail1.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail2.jpg`,
    ],
    videos: [],
    price: "50",
    rating: 4.8,
    time: "per rental",
    number_of_reviews: 85,
    duration: "15–30 min",
    language: "English, Albanian",
    itinerary: [
      { time: "Flexible", activity: "Meet at Durres Marina" },
      { time: "Start", activity: "Safety briefing and equipment" },
      { time: "Adventure", activity: "Jet ski ride along the coast" },
      { time: "End", activity: "Return to marina" },
    ],
    included: ["Safety equipment", "Life jackets", "Fuel", "Brief instruction"],
    notIncluded: ["Food & drinks", "Towels", "Photos"],
    packages: [
      {
        id: 1,
        name: "15 Min Rental",
        description: "Quick thrill on the Albanian coast",
        price_per_person: "50",
        duration: "15 minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail1.jpg`,
        included: [
          "Jet ski rental",
          "Safety equipment",
          "Fuel",
          "Life jackets",
        ],
      },
      {
        id: 2,
        name: "30 Min Rental",
        description: "More time to explore the coast",
        price_per_person: "90",
        duration: "30 minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail2.jpg`,
        included: [
          "Jet ski rental",
          "Safety equipment",
          "Fuel",
          "Life jackets",
        ],
      },
    ],
    availableTimes: ["09:00", "11:00", "14:00", "16:00", "18:00"],
  },
  {
    id: "bayliner",
    type: "boat",
    slug: "bayliner-water-sports",
    name: "Durrës: Bayliner Water Sports",
    location: "Durrës Marina",
    maxCapacity: 4,
    description:
      "Exciting water sports on our Bayliner boat, perfect for small groups of 1–4 people. Choose a quick 30-minute session (€100 total) or a full 60-minute experience (€150 total).",
    image: `${process.env.PUBLIC_URL}/images/speedboat/IMG_0358.jpeg`,
    price: "100",
    priceLabel: "per group (1–4 people)",
    rating: 5.0,
    time: "30–60 minutes",
    number_of_reviews: 0,
  },
];

export const packagesData = [
  {
    id: "speedboat",
    type: "boat",
    slug: "quicksilver-tour",
    title: " Durrës: Amaizing SpeedBoat Tour",
    name: " Durrës: Amaizing SpeedBoat Tour",
    location: "Durrës Marina",
    maxCapacity: 11,
    description:
      "Choose from 3 amazing tour packages on the QuickSilver 805: Explore a WWII shipwreck (90 min), enjoy coastal views with water sports (90 min), or book a private 4-hour adventure. Professional guides, modern boat with twin motors, unforgettable Albanian coast experience.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/quicksilver4.jpeg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver4.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver3.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver1.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver2.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver5.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver6.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver7.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver8.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver9.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver7.7.jpeg`,
    ],
    videos: [
      `${process.env.PUBLIC_URL}/videos/speedboat.mp4`,
      `${process.env.PUBLIC_URL}/videos/speedboat2.mp4`,
    ],
    // video: `${process.env.PUBLIC_URL}/videos/quicksilver-805.mp4`,
    price: "50",
    rating: 4.9,
    number_of_reviews: 110,
    duration: "by agreement",
    language: "English, Albanian",
    itinerary: [
      { time: "09:00", activity: "Departure from Durrës Marina" },
      { time: "09:30", activity: "Cruise along the Adriatic coast" },
      { time: "10:00", activity: "Swimming and photo stop" },
      { time: "10:30", activity: "Return to marina" },
    ],
    included: ["Skipper", "Life jackets", "Fuel", "Music system"],
    notIncluded: ["Food & drinks", "Towels"],
  },
  {
    id: "luxury-yacht",
    type: "yacht",
    title: "Premium Yacht Experience in Durrës",
    name: "Premium Yacht Experience in Durrës",
    location: "Durrës Marina",
    slug: "luxury-yacht-durres",
    maxCapacity: 11,
    description:
      "Experience the ultimate luxury on the Adriatic Sea with our premium yacht charter. Perfect for special occasions, corporate events, or simply indulging in the finest maritime experience. Our luxury yacht features spacious decks, elegant interiors, professional crew, gourmet catering options, and state-of-the-art amenities. Cruise along the stunning Albanian coastline, explore hidden coves, and enjoy VIP service with panoramic views of the Adriatic. Whether it's a romantic sunset cruise, a celebration with friends, or a corporate retreat, our yacht provides an unforgettable experience of elegance and comfort.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/yacht5.jpeg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/yacht5.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht2.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht3.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht4.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht1.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht6.jpeg`,
    ],
    // video: `${process.env.PUBLIC_URL}/videos/luxury-yacht.mp4`,
    price: "1300",
    priceType: "per 4 hours",
    time: "4 hours",
    rating: 5.0,
    number_of_reviews: 42,
    duration: "4 hours",
    language: "English, Albanian, Italian",
    itinerary: [
      { time: "10:00", activity: "Welcome aboard at Durrës Marina" },
      { time: "10:30", activity: "Departure & coastal cruise" },
      {
        time: "12:00",
        activity: "Swimming stop at secluded bay",
      },
      { time: "13:00", activity: "Gourmet lunch service onboard" },
      { time: "14:00", activity: "Return to marina" },
    ],
    included: [
      "Professional captain & crew",
      "Life jackets & safety equipment",
      "Fuel & marina fees",
      "Premium sound system",
      "Welcome drinks & 2 bottles of champagne",
      "Luxury sun deck & lounge areas",
      "Towels & beach amenities",
      "Water sports equipment",
      "Air conditioning",
      "Onboard restrooms",
      "Complimentary WiFi",
    ],
    notIncluded: [
      "Gourmet meals (can be arranged)",
      "Hotel pickup",
      "Gratuities",
    ],
    features: [
      "Spacious luxury yacht",
      "Professional crew service",
      "Premium amenities",
      "Water sports equipment",
      "Elegant interior design",
      "VIP experience",
      "Safety certified",
      "Full insurance coverage",
    ],
  },
  {
    id: "jet-ski",
    type: "jetski",
    slug: "jet-ski-adventure",
    title: "Durrës: Jet Ski Adventure",
    name: "Durrës: Jet Ski Adventure",
    location: "Durres Marina",
    maxCapacity: 11,
    description:
      "Experience the thrill of riding a jet ski on the beautiful Albanian coast. Choose between solo adventure or guided experience with a professional skipper.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
    images: [
      `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail1.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail2.jpg`,
    ],
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail1.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail2.jpg`,
    ],
    videos: [],
    price: "60",
    rating: 4.8,
    time: "per rental",
    number_of_reviews: 85,
    duration: "15–30 min",
    language: "English, Albanian",
    itinerary: [
      { time: "Flexible", activity: "Meet at Durres Marina" },
      { time: "Start", activity: "Safety briefing and equipment" },
      { time: "Adventure", activity: "Jet ski ride along the coast" },
      { time: "End", activity: "Return to marina" },
    ],
    included: ["Safety equipment", "Life jackets", "Fuel", "Brief instruction"],
    notIncluded: ["Food & drinks", "Towels", "Photos"],
    packages: [
      {
        id: 1,
        name: "15 Min Rental",
        description: "Quick thrill on the Albanian coast",
        price_per_person: "50",
        duration: "15 minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail1.jpg`,
        included: [
          "Jet ski rental",
          "Safety equipment",
          "Fuel",
          "Life jackets",
        ],
      },
      {
        id: 2,
        name: "30 Min Rental",
        description: "More time to explore the coast",
        price_per_person: "90",
        duration: "30 minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail2.jpg`,
        included: [
          "Jet ski rental",
          "Safety equipment",
          "Fuel",
          "Life jackets",
        ],
      },
    ],
    availableTimes: ["09:00", "11:00", "14:00", "16:00", "18:00"],
  },
  {
    id: "bayliner",
    type: "boat",
    slug: "bayliner-water-sports",
    title: "Durrës: Bayliner Water Sports",
    name: "Durrës: Bayliner Water Sports",
    location: "Durrës Marina",
    maxCapacity: 4,
    description:
      "Exciting water sports on our Bayliner boat, perfect for small groups of 1–4 people. Choose a quick 30-minute session (€100 total) or a full 60-minute experience (€150 total). Professional skipper included.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/IMG_0358.jpeg`,
    gallery: [`${process.env.PUBLIC_URL}/images/speedboat/IMG_0358.jpeg`],
    price: "100",
    priceLabel: "per group (1–4 people)",
    rating: 5.0,
    number_of_reviews: 36,
    duration: "30–60 min",
    language: "English, Albanian",
    itinerary: [
      { time: "Start", activity: "Meet at Durrës Marina" },
      { time: "5 min", activity: "Safety briefing & equipment" },
      { time: "Main", activity: "Water sports on the Adriatic" },
      { time: "End", activity: "Return to marina" },
    ],
    included: ["Skipper", "Life jackets", "Fuel", "Safety equipment"],
    notIncluded: ["Food & drinks", "Towels"],
  },
];
export const tourPackages = [
  {
    id: "speedboat",
    type: "boat",
    slug: "quicksilver-tour",
    name: " Durrës: Amaizing SpeedBoat Tour",
    location: "Durrës Marina",
    maxCapacity: 11,
    minCapacity: 1,
    description:
      "Choose from 2 amazing tour packages on the QuickSilver 805: Explore a WWII shipwreck (90 min), enjoy coastal views with water sports (90 min). Professional guides, modern boat with twin motors, unforgettable Albanian coast experience.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/quicksilver4.jpeg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver4.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver3.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver1.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver2.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver5.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver6.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver7.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver8.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver9.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver10.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/quicksilver7.7.jpeg`,
    ],
    videos: [
      `${process.env.PUBLIC_URL}/videos/speedboat.mp4`,
      `${process.env.PUBLIC_URL}/videos/speedboat2.mp4`,
    ],
    // video: `${process.env.PUBLIC_URL}/videos/quicksilver-805.mp4`,
    price: "50",
    time: "90 minutes",
    // price_1_4_persons: "200",
    // price_5_8_persons: "350",
    rating: 5.0,
    number_of_reviews: 110,
    duration: "by agreement",
    language: "English, Albanian",
    itinerary: [
      { time: "09:00", activity: "Departure from Durrës Marina" },
      { time: "09:30", activity: "Cruise along the Adriatic coast" },
      { time: "10:00", activity: "Swimming and photo stop" },
      { time: "10:30", activity: "Return to marina" },
    ],
    included: ["Skipper", "Life jackets", "Fuel", "Music system"],
    notIncluded: ["Food & drinks", "Towels"],
    extras: {
      drinks: [
        { name: "Water", price: 2 },
        { name: "Beer", price: 5 },
        { name: "Cola", price: 3 },
        { name: "Champagne", price: 30 },
      ],
      jetski: {
        name: "Jetski on Board",
        price: 50,
        duration: "15 min",
      },
    },
    packages: [
      {
        id: 3,
        name: "Boat Cruise",
        description:
          "Short and dynamic experience combining shipwreck or coastal highlights",
        price_per_person: "50",
        duration: "90 Minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/quicksilver1.jpeg`,
        badge: "🏆 Most Popular",
        group: "2–11 people",
        included: [
          "Guided boat tour",
          "Shipwreck or coastal highlight",
          "Professional local guide",
          "Safety equipment",
        ],
      },
      // Shipwreck Tour — hidden temporarily
      // {
      //   id: 1,
      //   name: "Shipwreck Tour",
      //   description:
      //     "Dive into history — visit a real WWII shipwreck off the Albanian coast",
      //   price_per_person: "65",
      //   duration: "90 Minutes",
      //   image: `${process.env.PUBLIC_URL}/images/speedboat/snorkelling.jpg`,
      //   badge: "🏆 Most Popular",
      //   included: [
      //     "Guided boat tour",
      //     "Visit to a World War II shipwreck",
      //     "Swimming & snorkeling stop",
      //     "Professional local guide",
      //   ],
      // },
      // TEMPORARILY DISABLED — re-enable by uncommenting the block below
      // {
      //   id: 2,
      //   name: "Coastal & Water Sports Tour",
      //   description:
      //     "Scenic coastal cruise combined with exciting water sports on the Adriatic",
      //   price_per_person: "65",
      //   duration: "90 Minutes",
      //   image: `${process.env.PUBLIC_URL}/images/speedboat/watersports.webp`,
      //   badge: "🌊 Adventure",
      //   included: [
      //     "Guided coastal boat tour",
      //     "Water Sports activity",
      //     "Scenic swim stop",
      //     "Safety equipment",
      //     "Professional guide",
      //   ],
      // },
      {
        id: 4,
        name: "Extended Sea Experience",
        description:
          "More time to explore, swim, and enjoy the coastline at a relaxed pace",
        price_per_person: "75",
        duration: "120 Minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/quicksilver2.jpeg`,
        badge: "🌅 Explorer",
        group: "2–11 people",
        included: [
          "Extended guided boat tour",
          "Multiple swimming stops",
          "Coastal sightseeing",
          "Professional local guide",
          "Safety equipment",
        ],
      },
    ],
    availableTimes: ["09:00", "17:00"],
  },
  {
    id: "luxury-yacht",
    type: "yacht",
    name: "Premium Yacht Experience in Durrës",
    location: "Durrës Marina",
    slug: "luxury-yacht-durres",
    description:
      "Experience the ultimate luxury on the Adriatic Sea with our premium yacht charter. Perfect for special occasions, corporate events, or simply indulging in the finest maritime experience. Our luxury yacht features spacious decks, elegant interiors, professional crew, gourmet catering options, and state-of-the-art amenities. Cruise along the stunning Albanian coastline, explore hidden coves, and enjoy VIP service with panoramic views of the Adriatic. Whether it's a romantic sunset cruise, a celebration with friends, or a corporate retreat, our yacht provides an unforgettable experience of elegance and comfort.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/yacht5.jpeg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/yacht5.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht2.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht3.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht4.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht1.jpeg`,
      `${process.env.PUBLIC_URL}/images/speedboat/yacht6.jpeg`,
    ],
    // video: `${process.env.PUBLIC_URL}/videos/luxury-yacht.mp4`,
    price: "1300",
    priceType: "per 4 hours",
    time: "4 hours",
    rating: 5.0,
    number_of_reviews: 42,
    duration: "4 hours",
    language: "English, Albanian, Italian",
    itinerary: [
      { time: "10:00", activity: "Welcome aboard at Durrës Marina" },
      { time: "10:30", activity: "Departure & coastal cruise" },
      {
        time: "12:00",
        activity: "Swimming stop at secluded bay",
      },
      { time: "13:00", activity: "Gourmet lunch service onboard" },
      { time: "14:00", activity: "Return to marina" },
    ],
    included: [
      "Professional captain & crew",
      "Life jackets & safety equipment",
      "Fuel & marina fees",
      "Premium sound system",
      "Welcome drinks & 2 bottles of champagne",
      "Luxury sun deck & lounge areas",
      "Towels & beach amenities",
      "Water sports equipment",
      "Air conditioning",
      "Onboard restrooms",
      "Complimentary WiFi",
    ],
    notIncluded: [
      "Gourmet meals (can be arranged)",
      "Hotel pickup",
      "Gratuities",
    ],
    features: [
      "Spacious luxury yacht",
      "Professional crew service",
      "Premium amenities",
      "Water sports equipment",
      "Elegant interior design",
      "VIP experience",
      "Safety certified",
      "Full insurance coverage",
    ],
  },
  {
    id: "jet-ski",
    type: "boat",
    slug: "jet-ski-adventure",
    name: "Durrës: Jet Ski Adventure",
    location: "Durres Marina",
    maxCapacity: 11,
    description:
      "Experience the thrill of riding a jet ski on the beautiful Albanian coast. Choose your rental duration: 15, 20, or 30 minutes.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
    gallery: [
      `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail1.jpg`,
      `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail2.jpg`,
    ],
    videos: [],
    price: "60",
    rating: 4.8,
    time: "per rental",
    number_of_reviews: 85,
    duration: "15–30 min",
    language: "English, Albanian",
    itinerary: [
      { time: "Flexible", activity: "Meet at Durres Marina" },
      { time: "Start", activity: "Safety briefing and equipment" },
      { time: "Adventure", activity: "Jet ski ride along the coast" },
      { time: "End", activity: "Return to marina" },
    ],
    included: ["Safety equipment", "Life jackets", "Fuel", "Brief instruction"],
    notIncluded: ["Food & drinks", "Towels", "Photos"],
    packages: [
      {
        id: 1,
        name: "15 Min Rental",
        description: "Quick thrill on the Albanian coast",
        price_per_person: "50",
        duration: "15 minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail1.jpg`,
        included: [
          "Jet ski rental",
          "Safety equipment",
          "Fuel",
          "Life jackets",
        ],
      },
      {
        id: 2,
        name: "30 Min Rental",
        description: "More time to explore the coast",
        price_per_person: "90",
        duration: "30 minutes",
        image: `${process.env.PUBLIC_URL}/images/speedboat/jetSkiDetail2.jpg`,
        included: [
          "Jet ski rental",
          "Safety equipment",
          "Fuel",
          "Life jackets",
        ],
      },
    ],
    availableTimes: ["09:00", "11:00", "14:00", "16:00", "18:00"],
  },
  {
    id: "bayliner",
    type: "boat",
    slug: "bayliner-water-sports",
    name: "Durrës: Bayliner Water Sports",
    location: "Durrës Marina",
    maxCapacity: 4,
    description:
      "Exciting water sports on our Bayliner boat, perfect for small groups of 1–4 people. Choose a quick 30-minute session (€100 total) or a full 60-minute experience (€150 total). Professional skipper, all safety equipment included.",
    image: `${process.env.PUBLIC_URL}/images/speedboat/IMG_0358.jpeg`,
    gallery: [`${process.env.PUBLIC_URL}/images/speedboat/IMG_0358.jpeg`],
    videos: [],
    price: "100",
    priceLabel: "per group (1–4 people)",
    rating: 5.0,
    time: "30–60 minutes",
    number_of_reviews: 0,
    duration: "30–60 min",
    language: "English, Albanian",
    itinerary: [
      { time: "Start", activity: "Meet at Durrës Marina" },
      { time: "5 min", activity: "Safety briefing & equipment" },
      { time: "Main", activity: "Water sports activity on the Adriatic" },
      { time: "End", activity: "Return to marina" },
    ],
    included: ["Skipper", "Life jackets", "Fuel", "Safety equipment"],
    notIncluded: ["Food & drinks", "Towels"],
    packages: [
      {
        id: 1,
        name: "Water Sports Session",
        description:
          "A fun 30-minute water sports session on the Adriatic — ideal for a quick sea thrill",
        price_per_group: "100",
        duration: "30 Minutes",
        badge: "🎯 Quick Thrill",
        group: "1–4 people",
        image: `${process.env.PUBLIC_URL}/images/speedboat/WhatsApp Image 2026-05-12 at 12.58.57.jpeg`,
        included: [
          "Water sports activity",
          "Safety equipment",
          "Life jackets",
          "Professional skipper",
          "Fuel",
        ],
      },
      {
        id: 2,
        name: "Extended Water Sports",
        description:
          "Full 60-minute water sports experience — more time on the sea for the full adventure",
        price_per_group: "150",
        duration: "60 Minutes",
        badge: "🎯 Full Experience",
        group: "1–4 people",
        image: `${process.env.PUBLIC_URL}/images/speedboat/WhatsApp Image 2026-05-12 at 12.58.57 (1).jpeg`,
        included: [
          "Extended water sports session",
          "Safety equipment",
          "Life jackets",
          "Professional skipper",
          "Fuel",
          "More coastal exploration",
        ],
      },
    ],
    availableTimes: [
      "09:00",
      "10:00",
      "11:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
    ],
  },
];

/* ── Service booking configuration ─────────────────────────────────── */
export const SERVICE_SLOT_CONFIG = {
  speedboat: {
    label: "Speedboat Tour",
    icon: "⚡",
    maxGuests: 11,
    timeSlots: [
      { time: "09:00 - 10:30", capacity: 11 },
      { time: "17:00 - 18:30", capacity: 11 },
    ],
    pricingModel: "per-person",
  },
  "jet-ski": {
    label: "Jet Ski Rental",
    icon: "🏄",
    maxGuests: 2,
    timeSlots: [
      { time: "09:00 - 10:00", capacity: 2 },
      { time: "11:00 - 12:00", capacity: 2 },
      { time: "16:00 - 17:00", capacity: 2 },
      { time: "18:00 - 19:00", capacity: 2 },
    ],
    pricingModel: "package",
    packages: [
      { id: "rental-15", label: "15 Min Rental", price: 50, riders: 1 },
      { id: "rental-30", label: "30 Min Rental", price: 90, riders: 1 },
    ],
  },
  "luxury-yacht": {
    label: "Luxury Yacht",
    icon: "⛵",
    maxGuests: 10,
    timeSlots: [
      { time: "10:00 - 14:00", capacity: 10 },
      { time: "16:00 - 20:00", capacity: 10 },
    ],
    pricingModel: "tiered",
    basePrice: 800,
    // basePersons: 5,
    // extraPerPerson: 50,
  },
};

export const travelPassions = [
  {
    id: 1,
    name: "Water Sports Experience",
    rating: "4.6",
    number_of_reviews: 147,
    image: `${process.env.PUBLIC_URL}/images/speedboat/watersports.jpg`,
  },
  {
    id: 2,
    name: "Jetski Adventure",
    rating: "4.6",
    number_of_reviews: 147,
    image: `${process.env.PUBLIC_URL}/images/speedboat/jetski.jpg`,
  },
  {
    id: 3,
    name: "SpeedBoats Guide",
    rating: "4.6",
    number_of_reviews: 147,
    image: `${process.env.PUBLIC_URL}/images/speedboat/wineSpeedBoat.jpeg`,
  },
  // {
  //   id: 4,
  //   name: "4-Wheeler Motorcycle Guide",
  //   rating: "4.6",
  //   number_of_reviews: 147,
  //   image: `${process.env.PUBLIC_URL}/images/atv/safari.jpg`,
  // },
];

export const rooms = [
  {
    id: 1,
    name: "economy room, annex building",
    conditions: ["Non-refundable", "Free Wifi", "Breakfast for 2 people"],
    price: 125,
  },
  {
    id: 2,
    name: "double room",
    conditions: ["Non-refundable", "Free Wifi", "Breakfast for 3 people"],
    price: 165,
  },
  {
    id: 3,
    name: "premium bedroom",
    conditions: [
      "Air Conditioning",
      "Breakfast for 3 people",
      "Flat-Screen TV",
      "Free Wifi",
    ],
    price: 323,
  },
];
